import { styled } from '@mui/material/styles';
import {
  BOXED_TEXT_BUTTON_BG,
  BOXED_TEXT_BUTTON_BORDER,
} from '@/theme/buttonTokens';
import TextButton from './TextButton';

/**
 * 박스형 텍스트 버튼 — TextButton 에 보더 박스와 배경 상태(enabled/hover/pressed)를 입힌 변형.
 * 라벨/아이콘/사이즈는 TextButton props 그대로 사용 (예: 결재↔협조 전환 버튼).
 */
const BoxedTextButton = styled(TextButton)`
  flex-shrink: 0;
  /* 우측 4px 는 endIcon 자체 여백 전제 — 시안 18050:533324 */
  padding: 4px 4px 4px 8px;
  border: 1px solid ${BOXED_TEXT_BUTTON_BORDER};
  background-color: ${BOXED_TEXT_BUTTON_BG.enabled};
  &:hover,
  &:focus,
  &:focus-visible {
    background-color: ${BOXED_TEXT_BUTTON_BG.hover};
  }
  &:active {
    background-color: ${BOXED_TEXT_BUTTON_BG.pressed};
  }
`;

export default BoxedTextButton;
